import { render, staticRenderFns } from "./ToggleAudioBtn.vue?vue&type=template&id=7dac8342&"
import script from "./ToggleAudioBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleAudioBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports